<template>
  <div>
    <div v-if="selectedKey === 'key_10'">
      <key-ten :status_key="'key_10'" />
    </div>
    <div v-if="selectedKey === 'key_19'">
      <key-common
        :key="selectedKey"
        :status_key="'key_19'"
        date_filter_key="status_date"
        date_filter_name="Returned Date"
        status_name="ReceivedToOriginWarehouse(FailedToDeliver)"
      />
    </div>
    <div v-if="selectedKey === 'key_20'">
      <key-twenty :status_key="'key_20'" />
    </div>
    <div v-if="selectedKey === 'key_23'">
      <key-common
        :key="selectedKey"
        :status_key="'key_23'"
        date_filter_key="status_date"
        date_filter_name="Recieved Date"
        status_name="ReturnDispatchFromMainWarehouse"
      />
    </div>
    <div v-if="selectedKey === 'key_28'">
      <key-twenty-eight
        :status_key="'key_28'"
        status_name="ReceivedToOriginWarehouse(InvalidDestination)"
      />
    </div>
    <div v-if="selectedKey === 'key_29'">
      <key-twenty-eight
        :status_key="'key_29'"
        status_name="DispatchedFromOriginWarehouse"
      />
    </div>
    <div v-if="selectedKey === 'key_35'">
      <key-thirty-five
        :key="selectedKey"
        :status_key="'key_35'"
        date_filter_key="status_date"
        date_filter_name="Recieved Date"
        status_name="ReceivedToSortingWarehouse"
      />
    </div>
    <div v-if="isCustomStatus">
      <key-custom
        :status_key="selectedKey"
        :status_actions="statusOptions.actions"
        :status_name="statusOptions.name"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions,camelcase
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import KeyCommon from '../../components/status-flow/KeyCommon.vue'
import KeyTen from '../../components/status-flow/KeyTen.vue'
import KeyTwentyEight from '../../components/status-flow/KeyTwentyEight.vue'
import KeyTwenty from '../../components/status-flow/KeyTwenty.vue'
import KeyThirtyFive from '../../components/status-flow/KeyThirtyFive.vue'
import KeyCustom from '../../components/status-flow/KeyCustom.vue'

const OrderRepository = RepositoryFactory.get('order')

export default {
  directives: {
    Ripple,
  },
  components: {
    KeyCommon,
    KeyTen,
    KeyTwentyEight,
    KeyTwenty,
    KeyThirtyFive,
    KeyCustom,
  },
  data() {
    return {
      selectedKey: '',
      selectedId: null,
      statusOptions: [],
    }
  },
  computed: {
    isCustomStatus() {
      return this.selectedKey.startsWith('cus_')
    },
  },
  mounted() {
    this.getKey()
  },
  methods: {
    getKey() {
      this.selectedKey = this.$route.params.key
      this.selectedId = this.$route.params.id
      if (this.isCustomStatus) {
        this.fetchStatusDetails()
      }
    },
    async fetchStatusDetails() {
      try {
        const { data } = (await OrderRepository.updateStatusId(this.selectedId)).data
        this.statusOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
  },
}
</script>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';
</style>
